export default "__VITE_ASSET__FRqulDya__"